/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export { OuiPage, OuiPageProps } from './page';

export { OuiPageBody, OuiPageBodyProps } from './page_body';

export {
  OuiPageContent,
  OuiPageContentProps,
  OuiPageContentBody,
  OuiPageContentBodyProps,
  OuiPageContentHeader,
  OuiPageContentHeaderProps,
  OuiPageContentHeaderSection,
  OuiPageContentHeaderSectionProps,
} from './page_content';

export {
  OuiPageHeader,
  OuiPageHeaderContent,
  OuiPageHeaderContentProps,
  OuiPageHeaderProps,
  OuiPageHeaderSection,
  OuiPageHeaderSectionProps,
} from './page_header';

export { OuiPageSideBar, OuiPageSideBarProps } from './page_side_bar';

export { OuiPageTemplate, OuiPageTemplateProps } from './page_template';
